import React, { Component, lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import asyncComponent from "../../helpers/AsyncFunc";
import "../../common/loader.css";

const routes = [
  {
    path: "",
    component: asyncComponent(() => import("../MainDashboard")),
  },
  {
    path: "newDashboard",
    component: asyncComponent(() => import("../NewDashboard")),
  },
  {
    path: "tiering-assessments",
    component: asyncComponent(() => import("../TieringAssessments")),
  },
  {
    path: "assessments",
    component: asyncComponent(() => import("../AssessmentsListing")),
  },
  {
    path: "breachAssessment",
    component: asyncComponent(() => import("../BreachAssessment")),
  },
  // {
  //   path: "GiveResponse",
  //   component: lazy(() => import("../AssessForm/GiveResponse")),
  // },
  {
    path: "GiveResponse",
    component: lazy(
      () => import("../Assessment/ProvideResponse/NewProvideResponse"),
    ),
  },
  {
    path: "ViewResponse",
    component: lazy(
      () => import("../Assessment/ProvideResponse/NewProvideResponse"),
    ),
  },
  // {
  //   path: "SurveyViewResponses",
  //   component: lazy(() => import("../SurveyViewResponses")),
  // },
  {
    path: "Profile",
    component: asyncComponent(() => import("../profile")),
  },
  {
    path: "Queries",
    component: asyncComponent(() => import("../QueryManagement")),
  },
  {
    path: "TermsAndConditionMaster",
    component: asyncComponent(() => import("../TermsAndConditions")),
  },
  {
    path: "ViewVendorDocumentDetails",
    component: lazy(() => import("../TermsAndConditions/ViewSummary")),
  },
  {
    path: "ViewVendorDocumentDetailsCompleted",
    component: lazy(() => import("../TermsAndConditions/ViewSummaryCompleted")),
  },
  {
    path: "ViewVendorDocumentDetailsReview",
    component: lazy(() => import("../TermsAndConditions/ViewSummaryReview")),
  },
];

class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    return (
      <div style={style}>
        <Suspense
          fallback={
            <div className="se-pre-con">
              {" "}
              <img src={require("../../image/loader.svg")} alt="hsgd" />
            </div>
          }
        >
          {routes.map((singleRoute) => {
            const { path, exact, ...otherProps } = singleRoute;
            return (
              <Route
                exact={exact === false ? false : true}
                key={singleRoute.path}
                path={`${url}/${singleRoute.path}`}
                {...otherProps}
              />
            );
          })}
        </Suspense>
      </div>
    );
  }
}

export default AppRouter;
